import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <SectionHeading
        eyebrow="Topics"
        title="按主题专区快速定位"
        desc="六个常年维护的内容方向，覆盖娱乐、科技、财经等高频话题。选一个方向进去，比在综合大厅里逐条翻更高效。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.slice(1).map((cat) => (
          <Link
            key={cat.id}
            to={`/topics?category=${cat.id}`}
            className="flex items-start gap-4 bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer group"
          >
            <span className="w-11 h-11 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-xl group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
              <i className={cat.icon} />
            </span>
            <span className="flex-1 min-w-0">
              <span className="flex items-center justify-between gap-3">
                <span className="font-heading text-base font-semibold text-foreground-950">{cat.name}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count} 条</span>
              </span>
              <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
            </span>
          </Link>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览全部话题
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}